import {getGuideActivitySlug} from "@repo/guide-core-helpers";
import {AIActivity} from "@repo/guide-types";

/**
 * Returns true if text-to-speech should be disabled for the given path.
 */
export const isTextToSpeechDisabledForPath = (pathname: string): boolean => {
    // We currently only disable text-to-speech for the chat with historical
    // figure activity.
    return (
        AIActivity.ChatWithHistoricalFigure === getGuideActivitySlug(pathname)
    );
};
